<template>
    <li
        ref="el"
        :data-productid="productId"
        :class="[
            '',
            $style['product-list-item'],
            productId == null ? $style['product-list-item--filler'] : '',
            isAuction ? $style['product-type-auction'] : '',
        ]"
        data-item-type="product"
        :data-page="page"
    >
        <div :class="['product-details', $style['product-details']]">
            <a
                :href="link ?? '#'"
                :aria-label="productName"
                :class="['product-image', $style['product-image']]"
                data-product-link
            >
                <div>
                    <filler
                        v-if="imgInfo == null"
                        box
                        aspect-ratio="4/3"
                    ></filler>
                    <product-image
                        :scale-of-screen="scaleOfScreen"
                        :item="imgInfo"
                        fill-width
                        :provided-image-width="mobile ? 228 : undefined"
                        :lazy="indexOfList == null || indexOfList > 4"
                        v-else
                    ></product-image>
                    <image-overlay
                        :type="overlayTextType"
                        v-if="overlayText != null"
                        >{{ overlayText }}</image-overlay
                    >
                    <image-overlay
                        type="third-party-stamp"
                        key="third-party-stamp"
                        v-if="thirdPartyStamp"
                    ></image-overlay>
                    <image-overlay
                        type="related-auction"
                        key="related-auction"
                        v-if="relatedAuctionStamp"
                    ></image-overlay>
                    <image-overlay
                        type="related-shop"
                        key="related-shop"
                        v-if="relatedShopStamp"
                    ></image-overlay>
                    <div
                        class="discount-badge"
                        v-if="
                            isShop &&
                            productValue != null &&
                            price != null &&
                            productValue > price &&
                            Math.round((1 - price / productValue) * 100) >= 10
                        "
                    >
                        {{
                            format(
                                labels.frontendProductList.discount,
                                Math.round((1 - price / productValue) * 100) +
                                    "%"
                            )
                        }}
                    </div>
                </div>
            </a>
            <div :class="['', $style['under-content']]">
                <div :class="['', $style['title-row']]" v-once>
                    <a
                        :href="link ?? '#'"
                        :aria-label="productName"
                        :class="['product-title', $style['product-title']]"
                        data-product-link
                    >
                        <span
                            ><filler
                                v-if="productName == null"
                                :max="70"
                            ></filler
                            ><template v-else>{{ productName }}</template></span
                        >
                    </a>
                </div>
                <div :class="['product-info', $style['product-info']]">
                    <specs
                        v-if="productId != null"
                        :product-id="productId"
                        :is-auction="isAuction"
                        :is-buynow="isBuynow"
                        :is-shop="isShop"
                        :product-value="productValue"
                        :price="price"
                        :price-comparison-enabled="priceComparisonEnabled"
                        :product-estimated-value="productValue"
                        :overwrite-settings="overwriteSettings"
                        :has-bid="hasBid"
                        @input="$emit('input', $event)"
                        :mobile="mobile"
                    >
                        <template
                            v-if="
                                secondsLeft != null &&
                                isValidSecondsleft(secondsLeft)
                            "
                        >
                            <div class="spec row product-time-row">
                                <div
                                    :class="{
                                        'header-text': true,
                                        time: mobile,
                                    }"
                                    >{{ timeLabel }}</div
                                ><template v-if="mobile">&nbsp;</template
                                ><div class="content-text time">
                                    <span
                                        class="countdown-text"
                                        :totalsecondsleft="secondsLeft"
                                        :status="
                                            timeIsNotStarted
                                                ? 'notStart'
                                                : 'started'
                                        "
                                        >{{ timeText }}</span
                                    >
                                </div>
                            </div>
                        </template>

                        <div
                            :class="{
                                'spec no-border-after buttons': true,
                                flex: !mobile,
                            }"
                        >
                            <div v-if="!mobile" class="spec col">
                                <action-button
                                    :action-button-text="actionButtonText"
                                    :product-id="productId"
                                    :link="link"
                                    @click="clickEvent($event)"
                                    :busy="actionButtonLoading"
                                ></action-button>
                            </div>
                            <template v-else>
                                <action-button
                                    :action-button-text="actionButtonText"
                                    :product-id="productId"
                                    :link="link"
                                    @click="clickEvent($event)"
                                    :busy="actionButtonLoading"
                                ></action-button>
                            </template>

                            <!--@{
                    var popupArguments = auctionId.HasValue ? (object)new { productId = Model.ProductId, auctionId } : new { productId = Model.ProductId };
                    }
                    @if (!WebsiteProvider.GetSiteParameterBool("Auction_DisableListBidAndBuy") && Model.TypeHasAuction && Model.TimeIsActive)
                    {
                        <div class="spec col">
                            <button id="BidPopUpBtn" type="button" data-productid="@Model.ProductId" class="action-button" onclick="productListPopup.call(this)" data-action="open-popup-bid" data-action-url="@Url.Action(" GenerateBidPopup", "AuctionProduct" , popupArguments)">
                                @Model.SiteVariables.Text("M_Auction_BidButtonText")
                            </button>
                        </div>
                    }
                    @if (!WebsiteProvider.GetSiteParameterBool("Auction_DisableListBidAndBuy") && showBuyNowButton)
                    {
                        <div class="spec col">
                            <button id="BuyNowPopUpBtn" type="button" data-productid="@Model.ProductId" class="action-button" onclick="productListPopup.call(this)" data-action="open-popup-buynow" data-action-url="@Url.Action(" GenerateBuyNowPopup", "AuctionProduct" , popupArguments)">
                                @Model.SiteVariables.Text(Model.TypeHasLoserOffer ? "M_Auction_LoserOffer_ButtonText" : "M_Checkout_BuyNow")
                            </button>
                        </div>
                    }-->
                        </div>

                        <fade-and-slide>
                            <div
                                :class="[
                                    $style['success-text'],
                                    'success-text',
                                ]"
                                v-if="
                                    !isNullOrWhitespace(cartLink) &&
                                    cartLink != null
                                "
                            >
                                <template
                                    v-for="textPart in mapLabels(
                                        labels.frontendProductpage.specs.addedToCart.split(
                                            '{0}'
                                        )
                                    )"
                                    >{{ textPart.txt
                                    }}<a
                                        v-if="
                                            textPart.i != textPart.a.length - 1
                                        "
                                        :href="cartLink"
                                        :class="$style['cart-link']"
                                        >{{
                                            labels.frontendProductpage.specs
                                                .addedToCartName
                                        }}</a
                                    ></template
                                >
                            </div>
                        </fade-and-slide>

                        <!--<template v-if="item.productTypeInt === 8">
                            <template v-if="item.productIsActive && item.timeIsActive && item.specialConfigurations.disableStockLimitations !== true">
                                <div :class="['spec', !mobile ? 'col' : 'row', 'shop-product-stock-status']">
                                    <div class="shop-product-stock-status-row">
                                        <span>
                                            <i :class="'icon-stock-status icon-stock-status--'+item.stockStatusIconCssClass"></i>
                                            {{item.stockStatusText}}
                                        </span>
                                    </div>
                                </div>
                            </template>
                        </template>-->
                    </specs>
                </div>
            </div>
        </div>
    </li>
</template>

<style scoped lang="scss">
@import "common.css.src/mixins.scss";

li {
    &:not(.list-end-item) {
        border: 1px solid #d7d7d7;
        border-radius: 5px;
        padding: 15px;
        /*height: 540px;*/
        @include when-desktop() {
            height: 320px;
            width: 700px;
            position: relative;
        }
    }

    &.list-end-item {
        display: block;
        flex-grow: 1;
        flex-basis: 100%;
    }

    box-sizing: content-box;

    @at-root .async-product-list #{&}.load-placeholder {
        opacity: 1;
        position: relative;
        height: 540px;

        @include when-desktop() {
            height: unset;
        }

        :before {
            display: block;
            position: absolute;
            top: 0px;
            left: 0px;
            bottom: 0px;
            right: 0px;
            background-color: rgba(221, 222, 224, 0.25);
            content: " ";
            visibility: visible;
            height: 100%;
            background-image: url(../../../../../../../mthemes/odendo.dk/images/ajax-loader.gif);
            background-repeat: no-repeat;
            background-position: center;
            width: 100%;
        }
    }

    .success-text {
        margin-top: 10px;
        font-size: 13px;
        @include when-desktop() {
            margin-top: revert;
        }
    }

    .product-image {
        /* flex: 1; */
        width: 100%;
        display: block;
        border: 1px solid #dddee0;
        box-sizing: border-box;
        vertical-align: top;
        position: relative;

        @include when-desktop() {
            /* flex: 1; */
            width: 55%;
            display: inline-block;
        }

        > div {
            width: 100%;
            /*padding-bottom: 75%;*/ /* 4:3 */
            background-size: cover;
            background-position: center;

            img {
                width: 100%;
                height: auto;
            }
        }
    }

    .product-title {
        display: block;
        font-weight: bold;
        margin-bottom: 15px;
        font-size: 14px;

        @include when-desktop() {
            font-weight: 700;
            white-space: nowrap;
            font-size: 15px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .product-details {
        width: 100%;
        padding: 0px;
        margin: 0;
        height: 100%;

        @include when-desktop() {
            display: flex;
            flex-direction: row;
            height: unset;
        }
    }

    .product-info {
        /* flex: 1; */
        width: 100%;
        display: block;
        vertical-align: top;
        /*margin-left: 15px;*/

        @include when-desktop() {
            /* flex: 1; */
            width: 45%;
            display: inline-block;
            position: relative;
            padding-left: 15px;
            box-sizing: border-box;
        }

        .spec {
            .header-text {
                font-weight: bold;
            }
            .content-text {
                font-weight: bold;
            }
            .content-text.price {
                font-size: 16px;
            }
            .header-text.time {
                display: inline-block;
            }
            .content-text.time {
                font-size: 14px;
                display: inline-block;
                @include when-desktop() {
                    font-size: 18px;
                }
            }
            .content-text.cause {
                font-size: 12px;
            }

            &.product-time-row {
                padding: 0;
                padding-top: 10px;
                padding-bottom: 10px;
            }

            &.row {
                text-align: center;
                padding: 10px;
            }

            &.flex {
                display: flex;
                justify-content: space-around;
                padding: 10px;

                .buttons {
                    justify-content: space-around;
                    padding-left: 0;
                    padding-right: 0;

                    .col {
                        flex: 0 1 auto;

                        @include when-desktop() {
                            flex: 1 1 100%;
                            + {
                                .col {
                                    margin-left: 4px;
                                }
                            }
                        }
                    }
                }
            }

            &.col {
                text-align: center;
                flex: 1;
            }

            @include when-desktop() {
                &.rel {
                    position: relative;
                }

                &.abs {
                    position: absolute;
                    width: 100%;
                    top: 0px;
                    bottom: 0px;
                }
            }

            &.row:not(.no-border-after) + .spec.row:not(.no-border-before),
            &.row:not(.no-border-after) + .spec.flex:not(.no-border-before),
            &.flex:not(.no-border-after) + .spec.row:not(.no-border-before),
            &.flex:not(.no-border-after) + .spec.flex:not(.no-border-before) {
                border-top: 1px solid #dddee0;
            }

            @include when-desktop() {
                &:not(.no-border-after) {
                    &:not(.col) {
                        + {
                            .spec {
                                &:not(.no-border-before) {
                                    &:not(.col) {
                                        border-top: 1px solid #dddee0;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    + li {
        margin-top: 15px;
    }

    &.advert-item {
        height: auto;

        @include when-desktop() {
            height: auto !important;
        }

        img.full-width {
            width: 100%;
            height: auto;
        }
    }

    .list-action-popup {
        @include when-desktop() {
            visibility: hidden;
            opacity: 0;
            z-index: 1;
            transition: opacity 400ms, visibility 0s;
            transition-delay: 0s, 400ms;
            position: absolute;
            top: 67px;
            border: 1px solid black;
            background-color: #fff;
            width: 300px;

            &[data-sender-action="open-popup-buynow"] {
                top: 186px;
            }

            &.visible {
                visibility: visible;
                opacity: 1;
                transition-delay: 0s, 0s;
            }
        }
    }
}

.discount-badge {
    position: absolute;
    top: 0;
    right: 0;
    background-color: #cccccc;
    padding: 5px 14px;
    text-transform: uppercase;
    font-weight: 600;
}

.list-action-popup {
    .bid-box {
        .buynow-content {
            display: flex;
            align-items: center;
            margin-top: 8px;
            width: 300px;

            @include when-desktop() {
                width: unset;
            }

            .action-button {
                width: auto;
                background-color: #000;
                color: #fff;
                box-sizing: border-box;
                border: none;
                border-radius: 5px;
                padding: 8px;
                font-size: inherit;
                font-weight: 700;
                cursor: pointer;
                display: inline-block;
            }
            > .col {
                &:first-child {
                    text-align: left;
                }
                &:last-child {
                    text-align: right;
                }
                flex: 1 1 auto;
                text-align: center;
            }
            .buynow-amount {
                width: 40px;
                text-align: center;
                font-size: 20px;
            }
        }
    }
    .specs-error-message {
        opacity: 0;
        height: 0px;
        margin-top: 0px;
        transition: opacity 400ms, margin 400ms;
        overflow: hidden;
        > div {
            color: #a94442;
            background-color: #f2dede;
            border-color: #ebccd1;
            padding: 10px;
            border-radius: 5px;
            transition: transform 400ms;
            transform: translateY(-100%);
        }
    }
    .specs-error-message.visible {
        opacity: 1;
        margin-top: 8px;
        height: auto;
        > div {
            transform: translateY(0%);
        }
    }
}

.product-image {
    .product-image-overlay-container {
        position: relative;
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }
    picture {
        + {
            .product-image-overlay-container {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                margin: 0;
                padding: 0;
                box-sizing: border-box;
            }
        }
    }
    .product-image-overlay.experience-city {
        display: block;
        position: absolute;
        top: 8px;
        left: 8px;
        min-width: 37%;
        background-color: #00b6b5;
        color: #000;
        font-weight: 700;
        font-size: 11pt;
        padding: 0;
        margin: 0;
        line-height: 2;
        font-family: "Open Sans Condensed", "Open Sans", sans-serif;
        text-transform: uppercase;
        text-align: center;
        padding-left: 5px;
        padding-right: 5px;
        box-sizing: border-box;
    }
}
.estimated-price-container {
    text-align: center;
    text-transform: uppercase;
    > span {
        color: #666;
        font-weight: 600;
        font-size: 12px;
    }
    &:not(.no-line-through) {
        > span {
            /*text-decoration: line-through;*/
            text-decoration: underline;
            color: #272727;
            font-family: "Open Sans";
            font-size: 12px;
            font-weight: normal;
            text-transform: none;
            line-height: 20px;
        }
    }
}

li {
    .auction-and-buynow {
        &:not(.price-comparison-enabled) {
            .price {
                font-size: 17px !important;
                margin-left: 15px;
                margin-right: 15px;
            }

            .header-text {
                &:not(.time) {
                    font-size: 13px !important;
                }
            }

            .action-button {
                @include when-desktop() {
                    font-size: 15px !important;
                }
            }
        }
    }
}

.spec.row.shop-product-stock-status {
    padding: 0 !important;
    margin-top: 10px;
    margin-bottom: 10px;
}

.product-list-segment-title {
    font-size: 22pt;
    font-weight: bold;
    text-transform: uppercase;
    margin-top: calc(1rem - 15px);
    margin-bottom: 1rem;
    text-align: center;
}
.empty-result {
    .product-list-segment-title {
        display: none;
    }
}
.product-list-segment {
    margin-bottom: 20px;
}
[data-has-custom-header="true"] {
    .product-list-segment-item-0 {
        .product-list-segment-title {
            display: none;
        }
    }
}

// filter

#productListFilterForm {
    &[data-changed="false"] {
        .product-list-filter-submit {
            display: none;
        }
    }
    &[data-changed="true"] {
        .resetFilterBtn {
            display: none;
        }
    }
}

.product-filter-column {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: -75%;
    opacity: 0;
    pointer-events: none;
    background: #fff;
    z-index: 999;
    box-shadow: 0 0px 20px rgba(0, 0, 0, 0.6);
    transition: left 0.4s, opacity 0.4s;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;

    &.open {
        opacity: 1;
        left: 0px;
        pointer-events: auto;
    }

    @include when-desktop() {
        position: initial;
        width: 205px;
        height: initial;
        top: initial;
        left: initial;
        opacity: initial;
        pointer-events: initial;
        z-index: initial;
        box-shadow: initial;
        box-sizing: initial;
        display: block;
        flex-direction: initial;
        align-items: initial;
        justify-content: initial;
    }

    .sort-selection {
        width: 100%;
    }

    .close-product-filter-btn {
        width: 30px;
        height: 30px;
        background-color: transparent;
        border-radius: 100%;
        border: none;
        padding: 0;
        font-size: 17px;
        vertical-align: middle;
        line-height: 0;
        &:before {
            display: inline;
            width: 100%;
            height: 100%;
            content: "×";
            font-size: 34px;
            font-weight: 600;
            color: #000;
        }
    }

    > div.product-group-filter {
        font-size: 17px;
        @include when-desktop() {
            overflow: hidden;
            font-size: 16px;
        }
        .product-groups {
            list-style: none;
            padding: 0;
            .product-groups {
                padding-left: 2px;
                font-family: "Open Sans Condensed", "Open Sans", sans-serif;
                font-weight: 300;
                .product-groups {
                    padding-left: 10px;
                }
            }
        }
        > .product-groups {
            > li[data-hasfiller-value="true"] {
                > label {
                    > .name {
                        &::after {
                            content: "";
                            display: inline-block;
                            background: url(../../../../../../../mthemes/odendo.dk/images/checkmark-2-sm.png);
                            background-repeat: no-repeat;
                            width: 18px;
                            height: 18px;
                            background-size: contain;
                            vertical-align: top;
                            position: absolute;
                        }
                    }
                }
            }
            > li {
                > label {
                    > .name {
                        cursor: pointer;
                        font-weight: bold;
                        font-family: "Open Sans Condensed", "Open Sans",
                            sans-serif;
                        text-transform: uppercase;
                        font-size: inherit;
                    }
                }
                > input[type="checkbox"][data-expand] {
                    &:not(:checked) {
                        ~ {
                            ul.product-groups {
                                visibility: hidden;
                                opacity: 0;
                                max-height: 0;
                                transition: opacity 400ms, max-height 400ms,
                                    visibility linear 0ms 400ms;
                                pointer-events: none;
                            }
                        }
                    }
                    &:checked {
                        ~ {
                            ul.product-groups {
                                visibility: visible;
                                opacity: 1;
                                max-height: 999px;
                                transition: opacity 400ms, max-height 400ms,
                                    visibility linear 0ms 0ms;
                                pointer-events: auto;
                            }
                        }
                    }
                }
            }
        }
    }
    .product-filter-options {
        list-style: none;
        padding: 0;
        > li {
            > label {
                cursor: pointer;
            }
        }
    }
}

@include desktop() {
    .productlist-geospecs {
        .header-text {
            font-size: 11px;
        }
        .tooltip-hint {
            &:before {
                font-size: 11px;
            }
            > div {
                font-size: 12px;
                font-weight: normal;
                text-transform: none;
            }
            > span {
                font-size: 12px;
                font-weight: normal;
                text-transform: none;
            }
        }
    }
}

.noProductContainer {
    @at-root .async-product-list:not(.empty-result) #{&} {
        display: none;
    }

    width: 100%;
    margin-top: 100px;
    margin-bottom: 100px;
    text-align: center;
    font-weight: 900;
    font-size: 14px;

    @include when-desktop() {
        margin-bottom: initial;
    }

    .col {
        width: 50%;
        margin-left: auto;
        margin-right: auto;
        .divider {
            border-top: 1px solid #d9dadc;
            display: block;
            line-height: 1px;
            margin: 15px 0;
            position: relative;
            text-align: center;
            .divider-title {
                background: #fff;
                font-size: 12px;
                letter-spacing: 1px;
                padding: 0 20px;
                text-transform: uppercase;
            }
        }
    }
    h2 {
        font-weight: bold;
        padding: 0;
        text-transform: none;
        font-family: "Open Sans Condensed", "Open Sans", sans-serif;
        margin: 0 0 5px 0;
        border: none;
        color: #333;
        text-shadow: none;
        line-height: 19px;
        background: none;
        border-radius: 0;
        text-align: center;
        font-size: 39px !important;

        @include when-desktop() {
            font-weight: 500;
        }
    }
    .editFilter {
        text-align: center;
        margin-top: 11% !important;
        margin-bottom: 30px !important;
        font-size: 20px;
        font-weight: bold;
        text-transform: uppercase;
    }
    .resetFilterBtn {
        width: 205px;
    }
}

.async-product-list {
    transition: all 0.4s;

    &.loading {
        background-size: 50px;
        min-height: 400px;

        @include when-desktop() {
            min-height: 400px;
            min-width: 700px;
        }
    }

    &.reset-loading {
        opacity: 0.65;
    }
}

.toggle-product-filter-btn {
    width: 100%;
    min-height: 1em;
    background: #707070;
    padding: 12px;
    box-sizing: border-box;
    margin-bottom: 15px;
    font-weight: bold;
    font-size: 14px;
    border: 2px solid #02b6b5;
    border-radius: 10em;
    background-color: #ececec;
    color: #272727;
}

.product-list-filter-logo-container {
    text-align: center;
}

.geolocation-info-type-3 {
    @include when-desktop() {
        font-weight: normal;
        font-style: italic;
    }
}

.product-list-with-filter {
    @at-root div#{&} {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
    }
    > .product-list-column {
        width: 100%;
    }
}

.block-article.geolocation-introduction {
    @include when-desktop() {
        h2 {
            margin-top: 2px;
        }
        .post-holder {
            padding: 0px 15px;
            box-sizing: border-box;
        }
    }
}
</style>

<style module>
.success-text {
    text-align: center;
}
.cart-link {
    text-decoration: underline;
}

.title-row {
    flex: 1;
    margin-bottom: auto;
}

.product-type-auction .title-row {
    text-transform: uppercase;
}

.product-type-auction .product-info {
    text-transform: uppercase;
}

.product-type-auction :global(.price.content-text) {
    font-size: 22px !important;
}

.product-image {
    width: 100% !important;
    border: none !important;
}

.product-title {
    margin-top: 0px !important;
    margin-bottom: 15px !important;
    white-space: normal !important;
    word-break: break-word;
    font-weight: normal !important;
    text-align: center;
}

.product-list-item {
    height: auto !important;
    width: auto !important;
    word-break: break-word;
    padding: 0px !important;
}
.product-list-item--filler {
    filter: saturate(0%);
}
.product-details {
    display: flex !important;
    flex-direction: column !important;
    height: 100% !important;
}

.product-info {
    display: block !important;
    width: initial !important;
    padding-left: 0 !important;
}

.under-content {
    margin: 15px;
    display: flex;
    flex-direction: column;
    height: 100%;
}

@media (max-width: 420px) {
    .under-content {
        margin: 10px;
    }
}
</style>

<script setup lang="ts">
import ImageOverlay from "../../../../../commons/product/overlays/image-overlay.vue";
import fallbackImage from "../../../../frontend-productpage/fallback-image.jpg?file";
import labels from "../../../../shared/labels";
import specs from "../common/product-specs.vue";
import productImage from "../common/product-image.vue";
import {
    type TrackingInformation,
    storeLinkTrackingInformation,
} from "../../../../../../utilities/product-link-tracking";
import Filler from "../../../../shared/Filler.vue";
import { type PropType, computed, onMounted, ref } from "vue";
import { type IProductPictureInfo } from "../../list-item";
import {
    format,
    isNullOrEmpty,
    isNullOrWhitespace,
} from "../../../../../../shared/utils/string";
import { isValidSecondsleft } from "../../../../../commons/product/auction/countdown";
import axios from "axios";
import {
    type AddToCartResponse,
    afterAddToCart,
} from "../../../../frontend-productpage/shop/cart-adding";
import FadeAndSlide from "../../../../shared/FadeAndSlide.vue";
import ActionButton from "./action-button.vue";
import { type OverwriteSettings } from "../../../../../commons/product/overwrite-settings";
import {
    ensureInitializedRegistration,
    type ProductRegistrationResult,
} from "../common/product-updater";

const timeText = ref("");

const props = defineProps({
    productId: Number,
    productName: String,
    page: Number,
    imageInfo: Object as PropType<IProductPictureInfo>,
    overlayText: String,
    overlayTextType: String,
    //overlayTextLink: String,
    indexOfList: Number,
    thirdPartyStamp: Boolean,
    relatedAuctionStamp: Boolean,
    relatedShopStamp: Boolean,
    isAuction: Boolean,
    isBuynow: Boolean,
    isShop: Boolean,
    productValue: Number,
    price: Number,
    mobile: Boolean,
    secondsLeft: Number,
    timeIsNotStarted: Boolean,
    overwriteSettings: Object as PropType<OverwriteSettings>,
    link: String,
    hasBid: Boolean,
    priceComparisonEnabled: Boolean,
    trackingInfo: Object as PropType<TrackingInformation>,
    scaleOfScreen: {
        type: Number,
        default: 1,
    },
    registration: Object as PropType<ProductRegistrationResult>,
});

function mapLabels(value: string[]) {
    return value.map((x: string, i: number, a: string[]) => ({
        i: i,
        txt: x,
        a: a,
    }));
}

const actionButtonText = computed(() => {
    if (addToCartAction.value) {
        return labels.frontendProductpage.specs.addToCart;
    }
    if (
        props.isShop &&
        !isNullOrEmpty(
            labels.frontendProductList.productSpecs.actionTexts.makeOffer_shop
        )
    )
        return labels.frontendProductList.productSpecs.actionTexts
            .makeOffer_shop;
    else if (
        props.isBuynow &&
        !isNullOrEmpty(
            labels.frontendProductList.productSpecs.actionTexts.makeOffer_buyNow
        )
    )
        return labels.frontendProductList.productSpecs.actionTexts
            .makeOffer_buyNow;
    else return labels.frontendProductList.productSpecs.actionTexts.makerOffer;
});

const emit = defineEmits([
    "input",
    "update:productId",
    "update:productName",
    "update:link",
    "update:overlayText",
    "update:overlayTextType",
    //"update:overlayTextLink",
    "update:thirdPartyStamp",
    "update:relatedAuctionStamp",
    "update:relatedShopStamp",
    "update:secondsLeft",
    "update:timeIsNotStarted",
    "update:isAuction",
    "update:isShop",
    "update:isBuynow",
    "update:productValue",
    "update:hasBid",
    "update:price",
]);

const cartLink = ref<string>();

const actionButtonLoading = ref(false);

async function clickEvent(ev: Event) {
    if (props.productId == null) {
        ev.preventDefault();
        return;
    }
    if (addToCartAction.value) {
        ev.preventDefault();
        actionButtonLoading.value = true;
        try {
            const response = await axios.post<AddToCartResponse>(
                "/auctionProduct/addToCart",
                undefined,
                {
                    params: {
                        productId: props.productId,
                        orderQuantity: 1,
                    },
                }
            );
            if (response.data.success !== true) {
                throw new Error(response.data.errors.join("\n"));
            }

            afterAddToCart(
                props.productId,
                response.data.cartItemsCount,
                response.data.firstAdd
            );

            cartLink.value = response.data.cartLink;

            return;
        } finally {
            actionButtonLoading.value = false;
        }
    }
}

const addToCartAction = computed(() => {
    if (props.isShop !== true) {
        return false;
    }
    return true;
});

const el = ref<HTMLLIElement>();

onMounted(() => {
    if (el.value == null) throw new Error("missing ref");

    ensureInitializedRegistration(props, emit, timeText);

    if (props.trackingInfo != null)
        storeLinkTrackingInformation(el.value, props.trackingInfo);
});

const timeLabel = computed(() => {
    if (props.isShop) {
        if (props.timeIsNotStarted)
            return labels.frontendProductList.productSpecs.headers
                .timeLeftToStart_shop;
        else
            return labels.frontendProductList.productSpecs.headers
                .timeLeft_shop;
    }
    if (props.timeIsNotStarted)
        return labels.frontendProductList.productSpecs.headers.timeLeftToStart;
    else return labels.frontendProductList.productSpecs.headers.timeLeft;
});

const imgInfo = computed(() => {
    if (props.imageInfo == null) return props.imageInfo;
    if (props.imageInfo.pictureUrl != null) return props.imageInfo;
    const res: IProductPictureInfo = {
        pictureUrl: fallbackImage,
        pictureWidth: 470,
        pictureHeight: 353,
        pictureSrcSet: undefined,
        pictureSrcSetAsWebp: undefined,
        pictureUrlAsWebp: undefined,
    };
    return res;
});
</script>
